import Utils from "../../../utils/index";

export default class TeamsLoginFailed {
    constructor() {
        Utils.hideLoader()
    }
}